import { Theme } from '@mui/material/styles';

export const getStyles = (theme: Theme) => ({
    classSubmittedDialog: {
        display: 'flex',
        flexDirection: 'column',
    },
    title: {
        color: theme.palette.primary.light,
    },
    message: {
        margin: theme.spacing(2, 0, 2, 0),
    },
    ok: {
        borderRadius: '100px',
        alignSelf: 'end',
    },
    formLabel: {
        background: '#FFF',
        alignSelf: 'baseline',
        position: 'relative',
        top: '-10px',
    },
    formContainer: {
        maxWidth: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(2),
    },
    formField: {
        maxWidth: '80%',
        display: 'flex',
        justifyContent: 'stretch',
        flexFlow: 'column wrap',
        flex: '1',
    },
    formButtons: {
        display: 'flex',
        justifyContent: 'flex-end',
        gap: theme.spacing(2),
    },
    saveForm: {
        borderRadius: '100px',
    },
    chip: {
        backgroundColor: '#e8f4fc',
    },
    doubleInput: {
        display: 'flex',
        gap: theme.spacing(2),
        flexWrap: 'wrap',
    },
    flexAuto: {
        flex: 1,
        minWidth: '200px',
    },
});
